<template>
  <el-card class="box-card">
    <div slot="header" class="box-head clearfix">
      <span class="card-head">Facebook Demographics</span>
      <el-popover
        :content="demographicsDescription[selectedDemographicType]"
        placement="bottom-start"
        trigger="hover"
      >
        <span slot="reference" class="fa fa-fw fa-info-circle"></span>
      </el-popover>

      <span class="pull-right">
        <el-select v-model="facebookPage" placeholder="Select Channel" size="mini">
          <el-option
            v-for="page in facebookPages"
            :key="page.id"
            :label="page.handle"
            :value="page.id"
          />
        </el-select>
      </span>

      <span class="pull-right">
        <el-radio-group v-model="demographicType" size="mini">
          <el-radio-button label="fans" />
          <!-- <el-radio-button label="engagements"/>
          <el-radio-button label="content"/> -->
        </el-radio-group>
      </span>
    </div>

    <div v-if="isLoading" class="card-content">
      <loader message="Loading demographics" shadow="none" />
    </div>
    <div v-else class="card-content">
      <div v-if="!hasData" class="placeholder">
        <content-placeholder
          :count="1"
          :text-only="true"
          :text-value="facebookPage ? 'No data' : 'No channel connected'"
        />
      </div>

      <div v-if="hasData" class="insights-container">
        <DemographicsItem
          v-for="(value, key) in demographicData"
          class="insight-item"
          :data="value"
          :label="key"
          :key="key"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import Loader from '@/components/common/Loader';
import ContentPlaceholder from '@/components/common/ContentPlaceholder';
import DemographicsItem from './DemographicsItem';

export default {
  name: 'PageDemographicsOverview',

  data: () => ({
    demographicsDescription: {
      fans: 'Aggregated lifetime demographic data about the people who like your Page based on the information they provide in their user profiles.',
      content:
        'Aggregated demographic data about the number of people who saw any content by your Page or about your Page over the past 28 days',
      engagements:
        'Aggregated demographic data about the number of people talking about your Page over the past 28 days',
    },
  }),

  props: {
    demographicData: {
      type: Object,
      default: () => ({}),
    },
    facebookPages: {
      type: Array,
      default: () => [],
    },
    selectedPage: {
      type: Number,
      default: null,
    },
    selectedDemographicType: {
      type: String,
      default: 'fans',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    facebookPage: {
      get() {
        return this.selectedPage;
      },
      set(value) {
        this.$emit('onSelectedPageChange', value);
      },
    },

    demographicType: {
      get() {
        return this.selectedDemographicType;
      },
      set(value) {
        this.$emit('onSelectedDemographicTypeChanged', value);
      },
    },

    hasData() {
      return (
        this.demographicData &&
        !!Object.values(this.demographicData).reduce((ac, x) => ac && x.length, true)
      );
    },
  },

  components: {
    DemographicsItem,
    Loader,
    ContentPlaceholder,
  },
};
</script>

<style lang="scss" scoped>
$my-text-color: #676a6c;

.insights-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.insight-item {
  display: inline-block;
  padding: 0;
}

.card-head {
  font-size: 1.3em;
}

.clearfix:after {
  clear: both;
}

.box-card {
  color: $my-text-color;
}

.box-head {
  height: 1.5em;
}

.card-content {
  min-height: 250px;
  margin: auto 20px;
}

.posts-placeholder {
  text-align: center;
  color: lighten($my-text-color, 25);
  font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// PageDemographicsOverview.vue?4735bee5